import axiosClient from "../../../shared/lib/axiosClient";
import { COURSE_API_BASE } from "../../../shared/utils/apiConfig";
import type { MyCourse, MyCoursesResponse } from "../types";

// Courses the logged-in user is enrolled in (session cookie is sent by axiosClient)
export const getMyCourses = async (signal?: AbortSignal): Promise<MyCourse[]> => {
    const { data } = await axiosClient.get<MyCoursesResponse>(`${COURSE_API_BASE}/user/`, {
        signal
    });

    if (!data.success) throw new Error("");
    return data.courses ?? [];
};